import React from 'react';
import PropTypes from 'prop-types';
import { SFEntityID, SFNavigationOptions } from '../utils/types';
import css from './UserContainer.css';
import UserInfoRow from './UserInfoRow';
import DismissButton from './DismissButton';
import Avatar from './Avatar';
import VisuallyHiddenSpan from '../common/VisuallyHiddenSpan';

export default class UserContainer extends React.Component {

  render() {
    return (
      <div className={css['user-container']} style={{'backgroundColor': this.props.headerColor}} aria-label="User Section">
        <div>
          <div>
            <Avatar isMobile={this.props.isMobile} id={this.props.id} photoURL={this.props.photoURL} />
            <VisuallyHiddenSpan text={`Avatar for ${this.props.name}`} />
          </div>
          <DismissButton onClick={this.props.onNavigationDismissed} />
        </div>
        <UserInfoRow
          isMobile={this.props.isMobile}
          name={this.props.name}
          utilitaryOptions={this.props.utilitaryOptions}
          currentSection={this.props.currentSection}
        />
      </div>
    );
  }
}

UserContainer.propTypes = {
  isMobile: PropTypes.bool,
  id: SFEntityID.isRequired,
  name: PropTypes.string.isRequired,
  photoURL: PropTypes.string.isRequired,
  utilitaryOptions: SFNavigationOptions.isRequired,
  onNavigationDismissed: PropTypes.func,
  currentSection: PropTypes.string,
  headerColor: PropTypes.string
};
